export default {
  appName: 'glasson-measurement'
}